import { useEffect, useState } from "react";

const CURRENT_VERSION = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck() {
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    if (import.meta.env.DEV) return;

    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        const data: { version?: string } = await res.json();
        if (data.version && data.version !== CURRENT_VERSION) {
          setIsStale(true);
        }
      } catch {
        // Network error — ignore
      }
    };

    const interval = setInterval(checkVersion, CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return { isStale };
}
